import { useContext, useState } from "react";
import { IdentifierMappingContext } from "../IdentifierMappingContext";
import { displayResponseErrors } from "../../utils/Helpers";

const parseErrorMessage = async (response) => {
  try {
    const data = await response.json();
    return displayResponseErrors(data?.errors) || "Failed to submit request.";
  } catch (e) {
    console.error(e);
    return "An unexpected server error occurred.";
  }
};

export function useIdentifierMappingSubmit({ onSubmitSuccess, body, url, successMessage }) {
  const { setPharmacyGroupTab, pharmacyGroupDetailsFetcher, pharmacyGroupsFetcher, setSnackbar } =
    useContext(IdentifierMappingContext);

  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document
            .querySelector('meta[name="csrf-token"]')
            ?.getAttribute("content"),
        },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const errorMessage = await parseErrorMessage(res);
        throw new Error(errorMessage);
      }

      setSnackbar({ severity: "success", message: successMessage });
      setPharmacyGroupTab("pending_requests");
      pharmacyGroupsFetcher.refresh();
      pharmacyGroupDetailsFetcher.refresh();
      onSubmitSuccess?.();
    } catch (error) {
      console.error(error);
      setSnackbar({ severity: "error", message: error.message });
    } finally {
      setSubmitting(false);
    }
  };

  return {
    submitting,
    handleSubmit,
  };
}
